import { z } from "zod";

export const gradeEnum = [
    {value: '0', label: 'بدون پایه'},
    {value: '1', label: 'هفتم'},
    {value: '2', label: 'هشتم'},
    {value: '3', label: 'نهم'},
    {value: '4', label: 'دهم'},
    {value: '5', label: 'یازدهم'},
    {value: '6', label: 'دوازدهم'},
    {value: '7', label: ''},
    {value: '8', label: ''},
    {value: '9', label: ''},
    {value: '10', label: 'ششم'}
]

export const majorEnum = [
    {value: '0', label: 'بدون رشته'},
    {value: '1', label: 'ریاضی', color: '#F26522' },
    {value: '2', label: 'تجربی', color: '#39B54A'},
    {value: '3', label: 'انسانی', color: '#56BFD8'},
    {value: '4', label: 'هنر', color: 'violet'}
]

export const GradeSchema = z.number().min(1).max(10);
export const MajorSchema = z.number().min(0).max(4);

export const TopicSchema = z.object({
    label: z.string(),
    group: z.string().nullable(),
    id: z.number().optional(),
    isHeader: z.boolean().optional()
})

export const LessonSchema = z.object({
    id: z.number().or(z.string()),
    title: z.string(),
    topics: z.array(TopicSchema).optional().nullable(),
    grade: GradeSchema,
    major: MajorSchema,
    color: z.string().optional().nullable(),
    short_title: z.string().optional().nullable()
})

export const LessonDefaultValues = { id: '-1', title: '', grade: 1, major: 0 }
export const TopicsDefaultValues = [{ label: 'فاقد مبحث پیشفرض', group: '0', id: 0 }];

export const LessonServerResponse = z.array(LessonSchema);
export const TopicsServerResponse = z.array(TopicSchema);

export type TopicType = z.infer<typeof TopicSchema>
export type LessonType = z.infer<typeof LessonSchema>
export type LessonServerType = z.infer<typeof LessonServerResponse>;
